<template>
	<div>
        <div class="left_sidebar">
            <ul>
                <li>
                    <router-link class="nav-link" v-bind:class="{active:checkCurrentRoute('Profile')}"  v-bind:to="'/profile/'">My Profile</router-link>
                </li>
                <li>
                    <router-link class="nav-link" v-bind:class="{active:checkCurrentRoute('MyCourses')}" v-bind:to="'/my-courses/'">My Courses</router-link>
                </li>
                <li>
                    <a class="nav-link" @click.prevent="logout">Logout</a>
                </li>                             
            </ul>
        </div>
	</div>
</template>
<script>
    import router from '../../router'
	export default {
        methods:{
            checkCurrentRoute(route){
                return (this.$route.name == route);
            },
            logout() {
                this.$store.commit('logout');
                router.push({name: 'Login',query: { logout: true }})
                return false;
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/User/UserSidebarMenu.vue